import React from 'react';
import PropTypes from 'prop-types';
import { Container, Title } from './style';

const PageTitle = ({ children }) => {
  return (
    <Container>
      <Title>{children}</Title>
    </Container>
  );
};

export default PageTitle;

PageTitle.propTypes = {
  children: PropTypes.string.isRequired,
};
